import React from 'react';
import {Row, Col, Card} from 'react-materialize';


import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"other_protection_title"} defaultMessage={"Outras Proteções"}/></b></p></h5>
            </div>
            <div align="justify" style={{padding:"50px"}}>
                <ul>
                    <li>• <FormattedMessage id={"other_protection_text_1"} defaultMessage={"Limpe e desinfete as botas."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_2"} defaultMessage={"Lava-pés."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_3"} defaultMessage={"Remova as roupas de trabalho antes de sair da fazenda."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_4"} defaultMessage={"Lave suas mãos com sabão e água."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_5"} defaultMessage={"Seque as mãos com papel toalha."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_6"} defaultMessage={"Nenhum equipamento de proteção individual deve ser compartilhado ou emprestado, mesmo após a desinfecção."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_7"} defaultMessage={"Se possível, tome um banho antes de ir para casa (ou assim que chegar)."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_8"} defaultMessage={"Coloque roupas limpas, mantidas em um espaço fechado."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_9"} defaultMessage={"Evite usar itens pessoais, como telefones celulares, nas áreas de produção/trabalho."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_10"} defaultMessage={"Use equipamento de proteção individual (EPI) apropriado."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_11"} defaultMessage={"Restrinja o acesso a pessoas desnecessárias em fazendas e locais de produção e processamento."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_12"} defaultMessage={"Evite contato desnecessário e desprotegido com animais [selvagens]."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_13"} defaultMessage={"Lave as mãos após o contato com animais ou produtos de origem animal."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_14"} defaultMessage={"Fique em casa se estiver se sentindo doente."}/></li>
                    <li>• <FormattedMessage id={"other_protection_text_15"} defaultMessage={"Se você tiver febre, tosse ou dificuldade em respirar, procure atendimento médico."}/></li>
                </ul>
            </div>
        </Row>

        <Row>
            <div align="center">
                <a href={"/covid"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>        

    </Card>

);

export default Sobre;